export default __webpack_public_path__ + "static/media/mapaGO.4a679dec.jpeg";